jQuery(function($){

	// home
	// $('.entries-grid article.entry-grid .entry-title').matchHeight();
	// $('.entries-grid article.entry-grid').matchHeight();

	// $('body.home article.entry.entry-grid .entry-title').matchHeight();
	// $('body.home article.entry.entry-grid .entry-content').matchHeight();
	// $('body.home article.entry.entry-grid').matchHeight();

	$('body.home .blog-startpage-grid-item .entry-title').matchHeight();
	$('body.home .blog-startpage-grid-item .entry-content').matchHeight();
	$('body.home .blog-startpage-grid-item').matchHeight();

	// posts
	$('.blog-archive-posts .blog-archive-post .blog-post-headline').matchHeight();
	$('.blog-archive-posts .blog-archive-post .blog-post-content').matchHeight();



	// adjust content-columns height
	var $equals = $("#site-content > .row > div[class^='col'], .products > li");
	setTimeout(function(){$equals.matchHeight();},1000);


	// modify pinterest plugin
	$('.pinterest_pins').on('click', function(e){
		e.preventDefault();
		var href = $(this).parent().parent().find('a').eq(0).attr('href');
		window.location.href = href;
	});

	// console.log('[1917]');

	// testmode
	const params = new URLSearchParams(window.location.search);
	const testmode_pname = 'tbtest';
	if (params.has(testmode_pname)) {
		const value = params.get(testmode_pname);
		if (value === '1') {
			$('#site-content').addClass('tbtest');
			console.log('tbtestmode active ...');
		} else {
			//
		}
	} else {
		//
	}

});